module.exports = __webpack_public_path__ + "static/media/remove.12333ffe.svg";